import HTTPRequestHandler from "../../../../utils/HTTPRequestHandler";
import { toast } from "react-toastify";

const urlInit = "provisioning/organizations/";
const httpRequestHandler = new HTTPRequestHandler();

export function fetchOrganizations() {
  return function (dispatch) {
    httpRequestHandler
      .get(urlInit)
      .then((response) => {
        dispatch({
          type: "FETCH_ORGANIZATIONS_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "FETCH_ORGANIZATIONS_FAILURE",
          error,
        });
      });
  };
}

export function addOrganization(
  newOrganization,
  successCallback,
  errorCallback
) {
  return function (dispatch) {
    httpRequestHandler
      .post(urlInit, newOrganization)
      .then((response) => {
        successCallback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
        toast(
          error.response?.data?.message ||
            error.response?.data?.name ||
            "Failed to add organization.",
          {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.TOP_CENTER,
          }
        );
      });
  };
}

export function editOrganization(
  id,
  updatedOrganization,
  successCallback,
  errorCallback
) {
  return function (dispatch) {
    httpRequestHandler
      .patch(`${urlInit}${id}/`, updatedOrganization)
      .then((response) => {
        successCallback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
        toast(
          error.response?.data?.message ||
            error.response?.data?.name ||
            "Failed to update organization.",
          {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.TOP_CENTER,
          }
        );
      });
  };
}

export function deleteOrganization(id, successCallback, errorCallback) {
  return function (dispatch) {
    httpRequestHandler
      .delete(`${urlInit}${id}/`)
      .then((response) => {
        successCallback(response.data);
      })
      .catch((error) => {
        errorCallback(error);
        toast(
          "Organization might be referenced by other data. Contact Administrator.",
          {
            autoClose: 5000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.TOP_CENTER,
          }
        );
      });
  };
}
